import React from 'react';
import styles from './CasinoModal.module.css';

const CasinoResultModal = ({
    show,
    onHide,
    title,
    children,
    roundId,
    matchTime,
    loading = false
}) => {
    if (!show) return null;

    return (
        <div className={`modal show d-block ${styles.modalOverlay}`} tabIndex="-1" role="dialog">
            <div className={`modal-dialog modal-lg ${styles.modalDialogCustom}`} role="document">
                <div className={`modal-content ${styles.casinoResultModal}`}>
                    <header id="__BVID__25___BV_modal_header_" className={`modal-header ${styles.modalHeader}`}>
                        <h5 id="__BVID__25___BV_modal_title_" className={`modal-title ${styles.modalTitle}`}>
                            {title || 'Casino Result'}
                        </h5>
                        <button
                            type="button"
                            className={`close ${styles.closeButton}`}
                            onClick={onHide}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </header>
                    <div className={`modal-body ${styles.modalBody}`}>
                        {loading ? (
                            <div className="text-center p-4">
                                <div className="spinner-border text-light" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            children
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CasinoResultModal;
